import { render, staticRenderFns } from "./feedback_entry_info.vue?vue&type=template&id=018d5cb4&"
import script from "./feedback_entry_info.vue?vue&type=script&lang=js&"
export * from "./feedback_entry_info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports